import React, { useEffect, useState } from 'react';
import API from "../api";
import { showSuccess, showError } from '../components/alerts';
function Student() {
    const [editid, setEditid] = useState('');
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        mobile: "",
        address: ""
    });
    const [students, setStudents] = useState({});
    const [errors, setErrors] = useState({});
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(true);
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
        setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    };
    const validate = () => {
        let errors = {};
        if (!formData.name.trim()) {
            errors.name = "Name is required";
        }
        if (!formData.email.trim()) {
            errors.email = "Email is required";
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            errors.email = "Invalid email format";
        }
        if (!formData.mobile.trim()) {
            errors.mobile = "Mobile is required";
        }
        if (!formData.address.trim()) {
            errors.address = "Address is required";
        }
        setErrors(errors);
        return Object.keys(errors).length === 0;
    };
    const addStduent = async (e) => {
        e.preventDefault();
        if (validate()) {

            if (editid) {
                // ✅ **Update Student**
                await API.put(`student/${editid}`, formData)
                    .then(() => {
                        showSuccess("Student Updated Successfully!");
                        setEditid('');
                        fetchStudents(0);
                        setErrors({});
                        setFormData({});
                    })
                    .catch((err) => console.error("Update Error:", err));
            } else {
                const response = await API.post('student', formData);
                // console.log(response);
                if (response.status) {
                    showSuccess('Student Added Successfully..');
                    setFormData({});
                    fetchStudents(0);
                    setErrors({});
                }
                else
                    showError(response.message);
            }
        }

    };
    useEffect(() => {
        fetchStudents(editid);
        if (!editid)
            setFormData({ name: "", email: "", mobile: "", address: "" });
    }, [editid]);

    const handleDelete = async (stduentId) => {
        if (window.confirm('Are you sure for want to delete this student.')) {
            try {
                setLoading(true);
                const response =await API.delete(`student/${stduentId}`);
                console.log(response);
                if (response.status) {
                    showSuccess('Student Deleted Successfully..');
                    setStudents(students.filter((student) => student.id !== stduentId));
                }
                else
                    setError(response.message);
            }
            catch (error) {
                setError("Failed to Delete students!");
            } finally {
                setLoading(false);
            }
        }
    }
    const fetchStudents = async (editid) => {
        try {
            const response = await API.get("student/" + editid);
            // console.log(response);
            // console.log(localStorage.getItem('token'));
            if (response.status) {
                if (editid)
                    setFormData(response.students);
                else
                    setStudents(response.students);
            }
            else
                setError(response.message);
        } catch (err) {
            setError("Failed to fetch students!");
        } finally {
            setLoading(false);
        }
    };
    return (
        <div className="row">
            <div className="col-md-5">
                <form onSubmit={addStduent}>
                    <div className="panel panel-primary">
                        <div className="panel-heading">
                            <h3 className="panel-title">{editid ? ` Edit` : ` Add`} Stduent</h3>
                        </div>
                        <div className="panel-body">
                            <div className="form-group">
                                <label htmlFor="name" className="form-label">Student Name</label>
                                <input type="text" className="form-control"
                                    id='name'
                                    name='name'
                                    onChange={handleChange}
                                    placeholder="Enter Name"
                                    value={formData.name} />
                                {errors.name && <span style={{ color: "red" }}>{errors.name}</span>}
                            </div>
                            <div className="form-group">
                                <label htmlFor="email" className="form-label">Email</label>
                                <input type="email" className="form-control"
                                    id='email'
                                    name='email'
                                    onChange={handleChange}
                                    placeholder="Enter Email"
                                    value={formData.email} />
                                {errors.email && <span style={{ color: "red" }}>{errors.email}</span>}
                            </div>
                            <div className="form-group">
                                <label htmlFor="mobile" className="form-label">Mobile</label>
                                <input type="text"
                                    id='mobile'
                                    name='mobile'
                                    onChange={handleChange}
                                    placeholder="Enter Mobile"
                                    value={formData.mobile} className="form-control" />
                                {errors.mobile && <span style={{ color: "red" }}>{errors.mobile}</span>}
                            </div>
                            <div className="form-group">
                                <label htmlFor="address" className="form-label">Address</label>
                                <textarea className='form-control' id="address" name='address'
                                    onChange={handleChange}
                                    placeholder="Enter Address"
                                    value={formData.address}
                                ></textarea>
                                {errors.address && <span style={{ color: "red" }}>{errors.address}</span>}
                            </div>
                        </div>
                        <div className="panel-footer">
                            <button className="btn btn-white btn-lg btn-success"><i className="fa fa-save"></i>{editid ? " Update" : " Save"}</button>
                            {editid && (<button onClick={() => { setEditid(0) }} className="btn btn-white btn-danger btn-lg">Cancel</button>)}
                        </div>
                    </div>
                </form>
            </div>
            <div className="col-md-7">
                <div className="panel panel-default">
                    <div className="panel-heading">
                        <h3 className="panel-title"><i className="fa fa-list"></i> List Stduent</h3>
                    </div>
                    <div className="panel-body">
                        {loading && <p>Loading...</p>}
                        {error && <p style={{ color: "red" }}>{error}</p>}
                        <div className="table-responsive">
                            <table className="table table-striped table-bordered">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Name</th>
                                        <th>Email</th>
                                        <th>Mobile</th>
                                        <th>Address</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {students.length &&
                                        students.map((student, index) => (
                                            <tr key={student.id}>
                                                <td>{index + 1}.</td>
                                                <td>{student.name}</td>
                                                <td>{student.email}</td>
                                                <td>{student.mobile}</td>
                                                <td>{student.address}</td>
                                                <td>
                                                    <button className='btn btn-info btn-white btn-xs' onClick={() => setEditid(student.id)}>
                                                        <i className='fa fa-edit'></i> Edit
                                                    </button>
                                                    <button className='btn btn-danger btn-white btn-xs' onClick={() => handleDelete(student.id)}>
                                                        <i className='fa fa-trash'></i> Delete
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Student;
